/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamRevisionPublishBotexamid200,
  GetApiV1ExamRevisionPublishBotexamid400,
  GetApiV1ExamRevisionPublishBotexamid401,
  GetApiV1ExamRevisionPublishBotexamid404,
  GetApiV1ExamRevisionPublishBotexamid500,
  GetApiV1ExamRevisionPublishBotexamidPathParams,
  GetApiV1ExamRevisionPublishBotexamidQueryResponse,
} from "../../types/examRevisionController/GetApiV1ExamRevisionPublishBotexamid.ts";
import { publishBotExamShowViewModelSchema } from "../publishBotExamShowViewModelSchema.ts";

export const getApiV1ExamRevisionPublishBotexamidPathParamsSchema = z.object({
  botExamId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ExamRevisionPublishBotexamidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamRevisionPublishBotexamid200Schema = z.lazy(
  () => publishBotExamShowViewModelSchema,
) as unknown as ToZod<GetApiV1ExamRevisionPublishBotexamid200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ExamRevisionPublishBotexamid400Schema =
  z.any() as unknown as ToZod<GetApiV1ExamRevisionPublishBotexamid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamRevisionPublishBotexamid401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamRevisionPublishBotexamid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ExamRevisionPublishBotexamid404Schema =
  z.any() as unknown as ToZod<GetApiV1ExamRevisionPublishBotexamid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamRevisionPublishBotexamid500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamRevisionPublishBotexamid500>;

export const getApiV1ExamRevisionPublishBotexamidQueryResponseSchema = z.lazy(
  () => getApiV1ExamRevisionPublishBotexamid200Schema,
) as unknown as ToZod<GetApiV1ExamRevisionPublishBotexamidQueryResponse>;
